<p-panel *ngIf="openingCommittee" [toggleable]="true" [collapsed]="eventCollapsed" [ngClass]="'align-top'">
  <p-header [ngClass]="getEventClass()">
    <i class="fas fa-calendar-alt"></i> {{ openingCommittee.description }}
  </p-header>
  <div>
    <div>
      <span>{{ 'Calendar.date' | translate }}:</span>
      {{ openingCommittee.date | date: 'dd/M/yy HH:mm' }}
      <ng-container *ngIf="!openingCommittee.date"><span class="noDate"></span></ng-container>
      ({{ getStateDescription(openingCommittee) }})
    </div>
    <div>
      <span>{{ 'ProcurementCommitteeDTO.evaluationCommittee' | translate }}:</span>
      {{ openingCommittee.evaluationCommittee?.description }}
    </div>
    <div>
      <span>{{ 'ProcurementCommitteeDTO.envelopes' | translate }}:</span>
      {{ getEnvelopes() }}
    </div>
  </div>
  <p-footer>
    <div class="flex-row d-flex justify-content-end">
      <div class="btn-group ">
        <button (click)="editData(openingCommittee,'EDIT_EVENTO_APER')" class="btn btn-sm btn-primary t-action-button"
          appNoDblClick [attr.disabled]="(isStarted(openingCommittee)) ? 'disabled' : null"
          title="{{ 'General.edit' | translate}}">
          <i class="fas fa-pencil-alt"></i>
        </button>
        <button (click)="deleteData(openingCommittee)" class="btn btn-sm btn-primary t-action-button" appNoDblClick
          [attr.disabled]="(isStarted(openingCommittee)) ? 'disabled' : null" title="{{ 'General.delete' | translate}}">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </p-footer>
</p-panel>
<div class="container-fuild py-2" *ngIf="!openingCommittee && getAvaliableEnvelopes().length > 0">
  <div class="flex-row">
    <div class="d-flex justify-content-end">
      <button class="btn btn-sm btn-outline-primary" aria-expanded="false" (click)="newData()" appNoDblClick
        title=" {{ 'ProcurementCommitteeDTO.add' | translate }}">
        <i class="fas fa-plus" aria-hidden="true"></i>
        {{ 'ProcurementCommitteeDTO.add' | translate }}
      </button>
    </div>
  </div>
</div>